const tsDataMath = {
  scale1: {
    "Locating Points": null,
    Arithmetic: null,
    "Creating Expressions": 0.0,
    "Exponents & Roots": 0.0,
    Expressions: 0.0,
    "Inequalities & Absolute Value": 0.0,
    "Properties of Algebra": null,
    Slope: 0.0,
    "Solving Equations": 0.0,
    "Equations: Coordinate Plane": null,
    "Equations: Modeling & Relations": null,
    "Creating Functions": 0.0,
    "Domain, Range & Function": null,
    "Function Graphs - Coordinate Plane": 0.0,
    "Function Graphs - Modeling & Relations": null,
    "Functions - Understanding & Evaluating": 0.0,
    Logarithms: null,
    Modeling: null,
    "Patterns & Sequences": 0.0,
    "Properties of Functions": null,
    "Trig Functions": 0.0,
    "Angles & Shapes": 0.0,
    "Area, Perimeter, Volume & Circumference": 0.0,
    "Circles & Parabolas - Coordinate Plane": 0.0,
    "Circles - Plane Geometry": 0.0,
    "Slope, Midpoint & Distance": 0.0,
    Logic: null,
    Symmetry: null,
    "Translation, Rotation, Reflection & Relative Equations": 0.0,
    Triangles: 0.0,
    "Trig Geometry": null,
    "Using Formulas": null,
    "Complex Numbers": 0.0,
    Computation: null,
    "Exponents & Place Value": 0.0,
    Factors: 0.0,
    Fractions: 0.0,
    Matrices: 0.0,
    "Number Concepts & Properties": 0.0,
    "Number Line & Absolute Value": null,
    "Averages, Median & Mode": null,
    Counting: 0.0,
    "Data Interpretation": 0.0,
    Probability: 0.0,
    "Studies & Models": null
  },
  scale2: {
    "Locating Points": null,
    Arithmetic: null,
    "Creating Expressions": null,
    "Exponents & Roots": null,
    Expressions: null,
    "Inequalities & Absolute Value": null,
    "Properties of Algebra": null,
    Slope: null,
    "Solving Equations": null,
    "Equations: Coordinate Plane": null,
    "Equations: Modeling & Relations": null,
    "Creating Functions": null,
    "Domain, Range & Function": null,
    "Function Graphs - Coordinate Plane": null,
    "Function Graphs - Modeling & Relations": null,
    "Functions - Understanding & Evaluating": null,
    Logarithms: null,
    Modeling: null,
    "Patterns & Sequences": null,
    "Properties of Functions": null,
    "Trig Functions": null,
    "Angles & Shapes": null,
    "Area, Perimeter, Volume & Circumference": null,
    "Circles & Parabolas - Coordinate Plane": null,
    "Circles - Plane Geometry": null,
    "Slope, Midpoint & Distance": null,
    Logic: null,
    Symmetry: null,
    "Translation, Rotation, Reflection & Relative Equations": null,
    Triangles: null,
    "Trig Geometry": null,
    "Using Formulas": null,
    "Complex Numbers": null,
    Computation: null,
    "Exponents & Place Value": null,
    Factors: null,
    Fractions: null,
    Matrices: null,
    "Number Concepts & Properties": null,
    "Number Line & Absolute Value": null,
    "Averages, Median & Mode": null,
    Counting: null,
    "Data Interpretation": null,
    Probability: null,
    "Studies & Models": null
  },
  scale3: {
    "Locating Points": null,
    Arithmetic: null,
    "Creating Expressions": 0,
    "Exponents & Roots": 0,
    Expressions: 0,
    "Inequalities & Absolute Value": 0,
    "Properties of Algebra": null,
    Slope: 0.0,
    "Solving Equations": 0,
    "Equations: Coordinate Plane": null,
    "Equations: Modeling & Relations": null,
    "Creating Functions": 0.0,
    "Domain, Range & Function": null,
    "Function Graphs - Coordinate Plane": 0,
    "Function Graphs - Modeling & Relations": null,
    "Functions - Understanding & Evaluating": 0,
    Logarithms: null,
    Modeling: null,
    "Patterns & Sequences": 0,
    "Properties of Functions": null,
    "Trig Functions": 0,
    "Angles & Shapes": 0,
    "Area, Perimeter, Volume & Circumference": null,
    "Circles & Parabolas - Coordinate Plane": 0.0,
    "Circles - Plane Geometry": 0,
    "Slope, Midpoint & Distance": null,
    Logic: null,
    Symmetry: null,
    "Translation, Rotation, Reflection & Relative Equations": null,
    Triangles: 0,
    "Trig Geometry": null,
    "Using Formulas": null,
    "Complex Numbers": null,
    Computation: null,
    "Exponents & Place Value": null,
    Factors: 0.0,
    Fractions: null,
    Matrices: 0,
    "Number Concepts & Properties": 0.0,
    "Number Line & Absolute Value": null,
    "Averages, Median & Mode": null,
    Counting: 0.030303,
    "Data Interpretation": null,
    Probability: 0.0,
    "Studies & Models": null
  },
  scale4: {
    "Locating Points": null,
    Arithmetic: null,
    "Creating Expressions": 0,
    "Exponents & Roots": 0,
    Expressions: 0,
    "Inequalities & Absolute Value": 0,
    "Properties of Algebra": null,
    Slope: null,
    "Solving Equations": 0,
    "Equations: Coordinate Plane": null,
    "Equations: Modeling & Relations": null,
    "Creating Functions": null,
    "Domain, Range & Function": null,
    "Function Graphs - Coordinate Plane": 0,
    "Function Graphs - Modeling & Relations": null,
    "Functions - Understanding & Evaluating": 0,
    Logarithms: null,
    Modeling: null,
    "Patterns & Sequences": 0,
    "Properties of Functions": null,
    "Trig Functions": 0,
    "Angles & Shapes": 0,
    "Area, Perimeter, Volume & Circumference": 0.010989,
    "Circles & Parabolas - Coordinate Plane": null,
    "Circles - Plane Geometry": 0,
    "Slope, Midpoint & Distance": 0.0,
    Logic: null,
    Symmetry: null,
    "Translation, Rotation, Reflection & Relative Equations": 0.0,
    Triangles: 0,
    "Trig Geometry": null,
    "Using Formulas": null,
    "Complex Numbers": 0.0,
    Computation: null,
    "Exponents & Place Value": 0.0,
    Factors: null,
    Fractions: 0.0,
    Matrices: 0,
    "Number Concepts & Properties": null,
    "Number Line & Absolute Value": null,
    "Averages, Median & Mode": null,
    Counting: null,
    "Data Interpretation": 0.0384615,
    Probability: null,
    "Studies & Models": null
  },
  scale5: {
    "Locating Points": null,
    Arithmetic: null,
    "Creating Expressions": 0,
    "Exponents & Roots": 0,
    Expressions: 0,
    "Inequalities & Absolute Value": 0,
    "Properties of Algebra": null,
    Slope: 0.012987,
    "Solving Equations": 0,
    "Equations: Coordinate Plane": null,
    "Equations: Modeling & Relations": null,
    "Creating Functions": 0.012987,
    "Domain, Range & Function": null,
    "Function Graphs - Coordinate Plane": 0,
    "Function Graphs - Modeling & Relations": null,
    "Functions - Understanding & Evaluating": 0,
    Logarithms: null,
    Modeling: null,
    "Patterns & Sequences": 0,
    "Properties of Functions": null,
    "Trig Functions": 0,
    "Angles & Shapes": 0,
    "Area, Perimeter, Volume & Circumference": null,
    "Circles & Parabolas - Coordinate Plane": 0.0,
    "Circles - Plane Geometry": 0,
    "Slope, Midpoint & Distance": null,
    Logic: null,
    Symmetry: null,
    "Translation, Rotation, Reflection & Relative Equations": null,
    Triangles: 0,
    "Trig Geometry": null,
    "Using Formulas": null,
    "Complex Numbers": null,
    Computation: null,
    "Exponents & Place Value": null,
    Factors: 0.025974,
    Fractions: null,
    Matrices: 0,
    "Number Concepts & Properties": 0.0,
    "Number Line & Absolute Value": null,
    "Averages, Median & Mode": null,
    Counting: 0.025974,
    "Data Interpretation": null,
    Probability: 0.012987,
    "Studies & Models": null
  },
  scale6: {
    "Locating Points": null,
    Arithmetic: null,
    "Creating Expressions": 0,
    "Exponents & Roots": 0,
    Expressions: 0,
    "Inequalities & Absolute Value": 0,
    "Properties of Algebra": null,
    Slope: null,
    "Solving Equations": 0,
    "Equations: Coordinate Plane": null,
    "Equations: Modeling & Relations": null,
    "Creating Functions": null,
    "Domain, Range & Function": null,
    "Function Graphs - Coordinate Plane": 0,
    "Function Graphs - Modeling & Relations": null,
    "Functions - Understanding & Evaluating": 0,
    Logarithms: null,
    Modeling: null,
    "Patterns & Sequences": 0,
    "Properties of Functions": null,
    "Trig Functions": 0,
    "Angles & Shapes": 0,
    "Area, Perimeter, Volume & Circumference": 0.0,
    "Circles & Parabolas - Coordinate Plane": null,
    "Circles - Plane Geometry": 0,
    "Slope, Midpoint & Distance": 0.0,
    Logic: null,
    Symmetry: null,
    "Translation, Rotation, Reflection & Relative Equations": 0.0,
    Triangles: 0,
    "Trig Geometry": null,
    "Using Formulas": null,
    "Complex Numbers": 0.0,
    Computation: null,
    "Exponents & Place Value": 0.15,
    Factors: null,
    Fractions: 0.025,
    Matrices: 0,
    "Number Concepts & Properties": null,
    "Number Line & Absolute Value": null,
    "Averages, Median & Mode": null,
    Counting: null,
    "Data Interpretation": 0.0,
    Probability: null,
    "Studies & Models": null
  },
  scale7: {
    "Locating Points": null,
    Arithmetic: null,
    "Creating Expressions": 0,
    "Exponents & Roots": 0,
    Expressions: 0,
    "Inequalities & Absolute Value": 0,
    "Properties of Algebra": null,
    Slope: 0.0217391,
    "Solving Equations": 0,
    "Equations: Coordinate Plane": null,
    "Equations: Modeling & Relations": null,
    "Creating Functions": 0.0108696,
    "Domain, Range & Function": null,
    "Function Graphs - Coordinate Plane": 0,
    "Function Graphs - Modeling & Relations": null,
    "Functions - Understanding & Evaluating": 0,
    Logarithms: null,
    Modeling: null,
    "Patterns & Sequences": 0,
    "Properties of Functions": null,
    "Trig Functions": 0,
    "Angles & Shapes": 0,
    "Area, Perimeter, Volume & Circumference": null,
    "Circles & Parabolas - Coordinate Plane": 0.076087,
    "Circles - Plane Geometry": 0,
    "Slope, Midpoint & Distance": null,
    Logic: null,
    Symmetry: null,
    "Translation, Rotation, Reflection & Relative Equations": null,
    Triangles: 0,
    "Trig Geometry": null,
    "Using Formulas": null,
    "Complex Numbers": null,
    Computation: null,
    "Exponents & Place Value": null,
    Factors: 0.0326087,
    Fractions: null,
    Matrices: 0,
    "Number Concepts & Properties": 0.0,
    "Number Line & Absolute Value": null,
    "Averages, Median & Mode": null,
    Counting: 0.0815217,
    "Data Interpretation": null,
    Probability: 0.0326087,
    "Studies & Models": null
  },
  scale8: {
    "Locating Points": null,
    Arithmetic: null,
    "Creating Expressions": 0,
    "Exponents & Roots": 0,
    Expressions: 0,
    "Inequalities & Absolute Value": 0,
    "Properties of Algebra": null,
    Slope: null,
    "Solving Equations": 0,
    "Equations: Coordinate Plane": null,
    "Equations: Modeling & Relations": null,
    "Creating Functions": null,
    "Domain, Range & Function": null,
    "Function Graphs - Coordinate Plane": 0,
    "Function Graphs - Modeling & Relations": null,
    "Functions - Understanding & Evaluating": 0,
    Logarithms: null,
    Modeling: null,
    "Patterns & Sequences": 0,
    "Properties of Functions": null,
    "Trig Functions": 0,
    "Angles & Shapes": 0,
    "Area, Perimeter, Volume & Circumference": 0.015873,
    "Circles & Parabolas - Coordinate Plane": null,
    "Circles - Plane Geometry": 0,
    "Slope, Midpoint & Distance": 0.0,
    Logic: null,
    Symmetry: null,
    "Translation, Rotation, Reflection & Relative Equations": 0.0,
    Triangles: 0,
    "Trig Geometry": null,
    "Using Formulas": null,
    "Complex Numbers": 0.0,
    Computation: null,
    "Exponents & Place Value": 0.148148,
    Factors: null,
    Fractions: 0.0555556,
    Matrices: 0,
    "Number Concepts & Properties": null,
    "Number Line & Absolute Value": null,
    "Averages, Median & Mode": null,
    Counting: null,
    "Data Interpretation": 0.037037,
    Probability: null,
    "Studies & Models": null
  },
  scale9: {
    "Locating Points": null,
    Arithmetic: null,
    "Creating Expressions": 0,
    "Exponents & Roots": 0,
    Expressions: 0,
    "Inequalities & Absolute Value": 0,
    "Properties of Algebra": null,
    Slope: 0.0438596,
    "Solving Equations": 0,
    "Equations: Coordinate Plane": null,
    "Equations: Modeling & Relations": null,
    "Creating Functions": 0.0263158,
    "Domain, Range & Function": null,
    "Function Graphs - Coordinate Plane": 0,
    "Function Graphs - Modeling & Relations": null,
    "Functions - Understanding & Evaluating": 0,
    Logarithms: null,
    Modeling: null,
    "Patterns & Sequences": 0,
    "Properties of Functions": null,
    "Trig Functions": 0,
    "Angles & Shapes": 0,
    "Area, Perimeter, Volume & Circumference": null,
    "Circles & Parabolas - Coordinate Plane": 0.0175439,
    "Circles - Plane Geometry": 0,
    "Slope, Midpoint & Distance": null,
    Logic: null,
    Symmetry: null,
    "Translation, Rotation, Reflection & Relative Equations": null,
    Triangles: 0,
    "Trig Geometry": null,
    "Using Formulas": null,
    "Complex Numbers": null,
    Computation: null,
    "Exponents & Place Value": null,
    Factors: 0.131579,
    Fractions: null,
    Matrices: 0,
    "Number Concepts & Properties": 0.0,
    "Number Line & Absolute Value": null,
    "Averages, Median & Mode": null,
    Counting: 0.0745614,
    "Data Interpretation": null,
    Probability: 0.0526316,
    "Studies & Models": null
  },
  scale10: {
    "Locating Points": null,
    Arithmetic: null,
    "Creating Expressions": 0.275309,
    "Exponents & Roots": 0.100617,
    Expressions: 0.0777778,
    "Inequalities & Absolute Value": 0.0469136,
    "Properties of Algebra": null,
    Slope: 0.0747664,
    "Solving Equations": 0.108642,
    "Equations: Coordinate Plane": null,
    "Equations: Modeling & Relations": null,
    "Creating Functions": 0.0700935,
    "Domain, Range & Function": null,
    "Function Graphs - Coordinate Plane": 0.0209877,
    "Function Graphs - Modeling & Relations": null,
    "Functions - Understanding & Evaluating": 0.091358,
    Logarithms: null,
    Modeling: null,
    "Patterns & Sequences": 0.082716,
    "Properties of Functions": null,
    "Trig Functions": 0.0166667,
    "Angles & Shapes": 0.0777778,
    "Area, Perimeter, Volume & Circumference": 0.0306122,
    "Circles & Parabolas - Coordinate Plane": 0.0233645,
    "Circles - Plane Geometry": 0.0734568,
    "Slope, Midpoint & Distance": 0.0119048,
    Logic: null,
    Symmetry: null,
    "Translation, Rotation, Reflection & Relative Equations": 0.0,
    Triangles: 0.0648148,
    "Trig Geometry": null,
    "Using Formulas": null,
    "Complex Numbers": 0.0238095,
    Computation: null,
    "Exponents & Place Value": 0.0714286,
    Factors: 0.130841,
    Fractions: 0.047619,
    Matrices: 0.0518519,
    "Number Concepts & Properties": 0.0233645,
    "Number Line & Absolute Value": null,
    "Averages, Median & Mode": null,
    Counting: 0.11215,
    "Data Interpretation": 0.0595238,
    Probability: 0.0747664,
    "Studies & Models": null
  },
  scale11: {
    "Locating Points": null,
    Arithmetic: null,
    "Creating Expressions": 0.300993,
    "Exponents & Roots": 0.127922,
    Expressions: 0.0826129,
    "Inequalities & Absolute Value": 0.07813,
    "Properties of Algebra": null,
    Slope: 0.14069,
    "Solving Equations": 0.113833,
    "Equations: Coordinate Plane": null,
    "Equations: Modeling & Relations": null,
    "Creating Functions": 0.129655,
    "Domain, Range & Function": null,
    "Function Graphs - Coordinate Plane": 0.0601985,
    "Function Graphs - Modeling & Relations": null,
    "Functions - Understanding & Evaluating": 0.0917387,
    Logarithms: null,
    Modeling: null,
    "Patterns & Sequences": 0.0694845,
    "Properties of Functions": null,
    "Trig Functions": 0.0472302,
    "Angles & Shapes": 0.0821326,
    "Area, Perimeter, Volume & Circumference": 0.0482218,
    "Circles & Parabolas - Coordinate Plane": 0.0910345,
    "Circles - Plane Geometry": 0.144092,
    "Slope, Midpoint & Distance": 0.0654008,
    Logic: null,
    Symmetry: null,
    "Translation, Rotation, Reflection & Relative Equations": 0.101266,
    Triangles: 0.0658021,
    "Trig Geometry": null,
    "Using Formulas": null,
    "Complex Numbers": 0.0464135,
    Computation: null,
    "Exponents & Place Value": 0.151899,
    Factors: 0.150345,
    Fractions: 0.0886076,
    Matrices: 0.0352225,
    "Number Concepts & Properties": 0.0662069,
    "Number Line & Absolute Value": null,
    "Averages, Median & Mode": null,
    Counting: 0.14069,
    "Data Interpretation": 0.109705,
    Probability: 0.12,
    "Studies & Models": null
  },
  scale12: {
    "Locating Points": null,
    Arithmetic: null,
    "Creating Expressions": 0.337247,
    "Exponents & Roots": 0.165938,
    Expressions: 0.105043,
    "Inequalities & Absolute Value": 0.122884,
    "Properties of Algebra": null,
    Slope: 0.14554,
    "Solving Equations": 0.13854,
    "Equations: Coordinate Plane": null,
    "Equations: Modeling & Relations": null,
    "Creating Functions": 0.199866,
    "Domain, Range & Function": null,
    "Function Graphs - Coordinate Plane": 0.0975787,
    "Function Graphs - Modeling & Relations": null,
    "Functions - Understanding & Evaluating": 0.116239,
    Logarithms: null,
    Modeling: null,
    "Patterns & Sequences": 0.100309,
    "Properties of Functions": null,
    "Trig Functions": 0.0827417,
    "Angles & Shapes": 0.122064,
    "Area, Perimeter, Volume & Circumference": 0.0672269,
    "Circles & Parabolas - Coordinate Plane": 0.128102,
    "Circles - Plane Geometry": 0.164846,
    "Slope, Midpoint & Distance": 0.0921569,
    Logic: null,
    Symmetry: null,
    "Translation, Rotation, Reflection & Relative Equations": 0.105882,
    Triangles: 0.114145,
    "Trig Geometry": null,
    "Using Formulas": null,
    "Complex Numbers": 0.137255,
    Computation: null,
    "Exponents & Place Value": 0.223529,
    Factors: 0.169685,
    Fractions: 0.103922,
    Matrices: 0.0517022,
    "Number Concepts & Properties": 0.107311,
    "Number Line & Absolute Value": null,
    "Averages, Median & Mode": null,
    Counting: 0.166667,
    "Data Interpretation": 0.105882,
    Probability: 0.157612,
    "Studies & Models": null
  },
  scale13: {
    "Locating Points": null,
    Arithmetic: null,
    "Creating Expressions": 0.319557,
    "Exponents & Roots": 0.196481,
    Expressions: 0.129857,
    "Inequalities & Absolute Value": 0.139418,
    "Properties of Algebra": null,
    Slope: 0.163458,
    "Solving Equations": 0.184953,
    "Equations: Coordinate Plane": null,
    "Equations: Modeling & Relations": null,
    "Creating Functions": 0.214029,
    "Domain, Range & Function": null,
    "Function Graphs - Coordinate Plane": 0.151556,
    "Function Graphs - Modeling & Relations": null,
    "Functions - Understanding & Evaluating": 0.145487,
    Logarithms: null,
    Modeling: null,
    "Patterns & Sequences": 0.144029,
    "Properties of Functions": null,
    "Trig Functions": 0.10514,
    "Angles & Shapes": 0.15888,
    "Area, Perimeter, Volume & Circumference": 0.106628,
    "Circles & Parabolas - Coordinate Plane": 0.159217,
    "Circles - Plane Geometry": 0.208381,
    "Slope, Midpoint & Distance": 0.152738,
    Logic: null,
    Symmetry: null,
    "Translation, Rotation, Reflection & Relative Equations": 0.123199,
    Triangles: 0.131383,
    "Trig Geometry": null,
    "Using Formulas": null,
    "Complex Numbers": 0.12536,
    Computation: null,
    "Exponents & Place Value": 0.182277,
    Factors: 0.188581,
    Fractions: 0.126441,
    Matrices: 0.0855089,
    "Number Concepts & Properties": 0.142577,
    "Number Line & Absolute Value": null,
    "Averages, Median & Mode": null,
    Counting: 0.193148,
    "Data Interpretation": 0.175072,
    Probability: 0.201631,
    "Studies & Models": null
  },
  scale14: {
    "Locating Points": null,
    Arithmetic: null,
    "Creating Expressions": 0.438262,
    "Exponents & Roots": 0.263712,
    Expressions: 0.169809,
    "Inequalities & Absolute Value": 0.184364,
    "Properties of Algebra": null,
    Slope: 0.220437,
    "Solving Equations": 0.235732,
    "Equations: Coordinate Plane": null,
    "Equations: Modeling & Relations": null,
    "Creating Functions": 0.272304,
    "Domain, Range & Function": null,
    "Function Graphs - Coordinate Plane": 0.176364,
    "Function Graphs - Modeling & Relations": null,
    "Functions - Understanding & Evaluating": 0.174642,
    Logarithms: null,
    Modeling: null,
    "Patterns & Sequences": 0.192104,
    "Properties of Functions": null,
    "Trig Functions": 0.12781,
    "Angles & Shapes": 0.204215,
    "Area, Perimeter, Volume & Circumference": 0.126962,
    "Circles & Parabolas - Coordinate Plane": 0.162368,
    "Circles - Plane Geometry": 0.234177,
    "Slope, Midpoint & Distance": 0.203289,
    Logic: null,
    Symmetry: null,
    "Translation, Rotation, Reflection & Relative Equations": 0.195241,
    Triangles: 0.147365,
    "Trig Geometry": null,
    "Using Formulas": null,
    "Complex Numbers": 0.226032,
    Computation: null,
    "Exponents & Place Value": 0.224633,
    Factors: 0.228471,
    Fractions: 0.141008,
    Matrices: 0.102367,
    "Number Concepts & Properties": 0.202819,
    "Number Line & Absolute Value": null,
    "Averages, Median & Mode": null,
    Counting: 0.240521,
    "Data Interpretation": 0.192442,
    Probability: 0.254827,
    "Studies & Models": null
  },
  scale15: {
    "Locating Points": null,
    Arithmetic: null,
    "Creating Expressions": 0.567636,
    "Exponents & Roots": 0.334257,
    Expressions: 0.22632,
    "Inequalities & Absolute Value": 0.226366,
    "Properties of Algebra": null,
    Slope: 0.274826,
    "Solving Equations": 0.321051,
    "Equations: Coordinate Plane": null,
    "Equations: Modeling & Relations": null,
    "Creating Functions": 0.366555,
    "Domain, Range & Function": null,
    "Function Graphs - Coordinate Plane": 0.222648,
    "Function Graphs - Modeling & Relations": null,
    "Functions - Understanding & Evaluating": 0.22299,
    Logarithms: null,
    Modeling: null,
    "Patterns & Sequences": 0.237792,
    "Properties of Functions": null,
    "Trig Functions": 0.148078,
    "Angles & Shapes": 0.268503,
    "Area, Perimeter, Volume & Circumference": 0.164831,
    "Circles & Parabolas - Coordinate Plane": 0.171823,
    "Circles - Plane Geometry": 0.288425,
    "Slope, Midpoint & Distance": 0.2226,
    Logic: null,
    Symmetry: null,
    "Translation, Rotation, Reflection & Relative Equations": 0.217687,
    Triangles: 0.157395,
    "Trig Geometry": null,
    "Using Formulas": null,
    "Complex Numbers": 0.203704,
    Computation: null,
    "Exponents & Place Value": 0.328042,
    Factors: 0.323803,
    Fractions: 0.216364,
    Matrices: 0.114882,
    "Number Concepts & Properties": 0.222152,
    "Number Line & Absolute Value": null,
    "Averages, Median & Mode": null,
    Counting: 0.307342,
    "Data Interpretation": 0.255669,
    Probability: 0.320195,
    "Studies & Models": null
  },
  scale16: {
    "Locating Points": null,
    Arithmetic: null,
    "Creating Expressions": 0.717235,
    "Exponents & Roots": 0.459632,
    Expressions: 0.329337,
    "Inequalities & Absolute Value": 0.275162,
    "Properties of Algebra": null,
    Slope: 0.349458,
    "Solving Equations": 0.443648,
    "Equations: Coordinate Plane": null,
    "Equations: Modeling & Relations": null,
    "Creating Functions": 0.498247,
    "Domain, Range & Function": null,
    "Function Graphs - Coordinate Plane": 0.255382,
    "Function Graphs - Modeling & Relations": null,
    "Functions - Understanding & Evaluating": 0.28527,
    Logarithms: null,
    Modeling: null,
    "Patterns & Sequences": 0.289646,
    "Properties of Functions": null,
    "Trig Functions": 0.156037,
    "Angles & Shapes": 0.354411,
    "Area, Perimeter, Volume & Circumference": 0.202269,
    "Circles & Parabolas - Coordinate Plane": 0.172936,
    "Circles - Plane Geometry": 0.345561,
    "Slope, Midpoint & Distance": 0.250124,
    Logic: null,
    Symmetry: null,
    "Translation, Rotation, Reflection & Relative Equations": 0.291315,
    Triangles: 0.199534,
    "Trig Geometry": null,
    "Using Formulas": null,
    "Complex Numbers": 0.216873,
    Computation: null,
    "Exponents & Place Value": 0.439702,
    Factors: 0.504543,
    Fractions: 0.331514,
    Matrices: 0.123184,
    "Number Concepts & Properties": 0.241712,
    "Number Line & Absolute Value": null,
    "Averages, Median & Mode": null,
    Counting: 0.424091,
    "Data Interpretation": 0.363275,
    Probability: 0.390182,
    "Studies & Models": null
  },
  scale17: {
    "Locating Points": null,
    Arithmetic: null,
    "Creating Expressions": 0.778198,
    "Exponents & Roots": 0.555938,
    Expressions: 0.415669,
    "Inequalities & Absolute Value": 0.3176,
    "Properties of Algebra": null,
    Slope: 0.457358,
    "Solving Equations": 0.544516,
    "Equations: Coordinate Plane": null,
    "Equations: Modeling & Relations": null,
    "Creating Functions": 0.627072,
    "Domain, Range & Function": null,
    "Function Graphs - Coordinate Plane": 0.285033,
    "Function Graphs - Modeling & Relations": null,
    "Functions - Understanding & Evaluating": 0.349296,
    Logarithms: null,
    Modeling: null,
    "Patterns & Sequences": 0.327462,
    "Properties of Functions": null,
    "Trig Functions": 0.152654,
    "Angles & Shapes": 0.418054,
    "Area, Perimeter, Volume & Circumference": 0.240248,
    "Circles & Parabolas - Coordinate Plane": 0.176209,
    "Circles - Plane Geometry": 0.414522,
    "Slope, Midpoint & Distance": 0.306497,
    Logic: null,
    Symmetry: null,
    "Translation, Rotation, Reflection & Relative Equations": 0.377589,
    Triangles: 0.246434,
    "Trig Geometry": null,
    "Using Formulas": null,
    "Complex Numbers": 0.241996,
    Computation: null,
    "Exponents & Place Value": 0.533898,
    Factors: 0.623996,
    Fractions: 0.479284,
    Matrices: 0.144672,
    "Number Concepts & Properties": 0.262348,
    "Number Line & Absolute Value": null,
    "Averages, Median & Mode": null,
    Counting: 0.520595,
    "Data Interpretation": 0.446328,
    Probability: 0.460263,
    "Studies & Models": null
  },
  scale18: {
    "Locating Points": null,
    Arithmetic: null,
    "Creating Expressions": 0.779126,
    "Exponents & Roots": 0.578449,
    Expressions: 0.465694,
    "Inequalities & Absolute Value": 0.328146,
    "Properties of Algebra": null,
    Slope: 0.526987,
    "Solving Equations": 0.5928,
    "Equations: Coordinate Plane": null,
    "Equations: Modeling & Relations": null,
    "Creating Functions": 0.714426,
    "Domain, Range & Function": null,
    "Function Graphs - Coordinate Plane": 0.320326,
    "Function Graphs - Modeling & Relations": null,
    "Functions - Understanding & Evaluating": 0.38656,
    Logarithms: null,
    Modeling: null,
    "Patterns & Sequences": 0.371604,
    "Properties of Functions": null,
    "Trig Functions": 0.156293,
    "Angles & Shapes": 0.470209,
    "Area, Perimeter, Volume & Circumference": 0.27104,
    "Circles & Parabolas - Coordinate Plane": 0.196598,
    "Circles - Plane Geometry": 0.469524,
    "Slope, Midpoint & Distance": 0.331064,
    Logic: null,
    Symmetry: null,
    "Translation, Rotation, Reflection & Relative Equations": 0.445545,
    Triangles: 0.297388,
    "Trig Geometry": null,
    "Using Formulas": null,
    "Complex Numbers": 0.27599,
    Computation: null,
    "Exponents & Place Value": 0.654703,
    Factors: 0.703631,
    Fractions: 0.57797,
    Matrices: 0.171733,
    "Number Concepts & Properties": 0.295715,
    "Number Line & Absolute Value": null,
    "Averages, Median & Mode": null,
    Counting: 0.570821,
    "Data Interpretation": 0.499381,
    Probability: 0.498855,
    "Studies & Models": null
  },
  scale19: {
    "Locating Points": null,
    Arithmetic: null,
    "Creating Expressions": 0.809059,
    "Exponents & Roots": 0.644865,
    Expressions: 0.496813,
    "Inequalities & Absolute Value": 0.375091,
    "Properties of Algebra": null,
    Slope: 0.616138,
    "Solving Equations": 0.635043,
    "Equations: Coordinate Plane": null,
    "Equations: Modeling & Relations": null,
    "Creating Functions": 0.744614,
    "Domain, Range & Function": null,
    "Function Graphs - Coordinate Plane": 0.356912,
    "Function Graphs - Modeling & Relations": null,
    "Functions - Understanding & Evaluating": 0.451311,
    Logarithms: null,
    Modeling: null,
    "Patterns & Sequences": 0.360986,
    "Properties of Functions": null,
    "Trig Functions": 0.148992,
    "Angles & Shapes": 0.492843,
    "Area, Perimeter, Volume & Circumference": 0.331441,
    "Circles & Parabolas - Coordinate Plane": 0.188014,
    "Circles - Plane Geometry": 0.486626,
    "Slope, Midpoint & Distance": 0.40272,
    Logic: null,
    Symmetry: null,
    "Translation, Rotation, Reflection & Relative Equations": 0.527197,
    Triangles: 0.365897,
    "Trig Geometry": null,
    "Using Formulas": null,
    "Complex Numbers": 0.307531,
    Computation: null,
    "Exponents & Place Value": 0.665272,
    Factors: 0.705836,
    Fractions: 0.651674,
    Matrices: 0.181695,
    "Number Concepts & Properties": 0.278104,
    "Number Line & Absolute Value": null,
    "Averages, Median & Mode": null,
    Counting: 0.607325,
    "Data Interpretation": 0.486402,
    Probability: 0.575793,
    "Studies & Models": null
  },
  scale20: {
    "Locating Points": null,
    Arithmetic: null,
    "Creating Expressions": 0.874493,
    "Exponents & Roots": 0.724458,
    Expressions: 0.544654,
    "Inequalities & Absolute Value": 0.411041,
    "Properties of Algebra": null,
    Slope: 0.676594,
    "Solving Equations": 0.657792,
    "Equations: Coordinate Plane": null,
    "Equations: Modeling & Relations": null,
    "Creating Functions": 0.817124,
    "Domain, Range & Function": null,
    "Function Graphs - Coordinate Plane": 0.412159,
    "Function Graphs - Modeling & Relations": null,
    "Functions - Understanding & Evaluating": 0.479455,
    Logarithms: null,
    Modeling: null,
    "Patterns & Sequences": 0.347729,
    "Properties of Functions": null,
    "Trig Functions": 0.148218,
    "Angles & Shapes": 0.523201,
    "Area, Perimeter, Volume & Circumference": 0.315577,
    "Circles & Parabolas - Coordinate Plane": 0.232666,
    "Circles - Plane Geometry": 0.501258,
    "Slope, Midpoint & Distance": 0.40678,
    Logic: null,
    Symmetry: null,
    "Translation, Rotation, Reflection & Relative Equations": 0.615819,
    Triangles: 0.425926,
    "Trig Geometry": null,
    "Using Formulas": null,
    "Complex Numbers": 0.293785,
    Computation: null,
    "Exponents & Place Value": 0.740113,
    Factors: 0.760354,
    Fractions: 0.714689,
    Matrices: 0.186303,
    "Number Concepts & Properties": 0.29316,
    "Number Line & Absolute Value": null,
    "Averages, Median & Mode": null,
    Counting: 0.673802,
    "Data Interpretation": 0.511299,
    Probability: 0.595161,
    "Studies & Models": null
  },
  scale21: {
    "Locating Points": null,
    Arithmetic: null,
    "Creating Expressions": 0.781151,
    "Exponents & Roots": 0.657038,
    Expressions: 0.553733,
    "Inequalities & Absolute Value": 0.372827,
    "Properties of Algebra": null,
    Slope: 0.696559,
    "Solving Equations": 0.677356,
    "Equations: Coordinate Plane": null,
    "Equations: Modeling & Relations": null,
    "Creating Functions": 0.816475,
    "Domain, Range & Function": null,
    "Function Graphs - Coordinate Plane": 0.408323,
    "Function Graphs - Modeling & Relations": null,
    "Functions - Understanding & Evaluating": 0.523011,
    Logarithms: null,
    Modeling: null,
    "Patterns & Sequences": 0.4541,
    "Properties of Functions": null,
    "Trig Functions": 0.17295,
    "Angles & Shapes": 0.558507,
    "Area, Perimeter, Volume & Circumference": 0.360927,
    "Circles & Parabolas - Coordinate Plane": 0.224192,
    "Circles - Plane Geometry": 0.547613,
    "Slope, Midpoint & Distance": 0.453642,
    Logic: null,
    Symmetry: null,
    "Translation, Rotation, Reflection & Relative Equations": 0.55298,
    Triangles: 0.475275,
    "Trig Geometry": null,
    "Using Formulas": null,
    "Complex Numbers": 0.271523,
    Computation: null,
    "Exponents & Place Value": 0.715232,
    Factors: 0.771637,
    Fractions: 0.715232,
    Matrices: 0.203672,
    "Number Concepts & Properties": 0.295099,
    "Number Line & Absolute Value": null,
    "Averages, Median & Mode": null,
    Counting: 0.713243,
    "Data Interpretation": 0.516556,
    Probability: 0.663191,
    "Studies & Models": null
  },
  scale22: {
    "Locating Points": null,
    Arithmetic: null,
    "Creating Expressions": 0.863971,
    "Exponents & Roots": 0.755734,
    Expressions: 0.583961,
    "Inequalities & Absolute Value": 0.423238,
    "Properties of Algebra": null,
    Slope: 0.740299,
    "Solving Equations": 0.681316,
    "Equations: Coordinate Plane": null,
    "Equations: Modeling & Relations": null,
    "Creating Functions": 0.863881,
    "Domain, Range & Function": null,
    "Function Graphs - Coordinate Plane": 0.503432,
    "Function Graphs - Modeling & Relations": null,
    "Functions - Understanding & Evaluating": 0.5704,
    Logarithms: null,
    Modeling: null,
    "Patterns & Sequences": 0.370166,
    "Properties of Functions": null,
    "Trig Functions": 0.157207,
    "Angles & Shapes": 0.586724,
    "Area, Perimeter, Volume & Circumference": 0.374322,
    "Circles & Parabolas - Coordinate Plane": 0.261493,
    "Circles - Plane Geometry": 0.571823,
    "Slope, Midpoint & Distance": 0.508439,
    Logic: null,
    Symmetry: null,
    "Translation, Rotation, Reflection & Relative Equations": 0.666667,
    Triangles: 0.537921,
    "Trig Geometry": null,
    "Using Formulas": null,
    "Complex Numbers": 0.438819,
    Computation: null,
    "Exponents & Place Value": 0.746835,
    Factors: 0.784478,
    Fractions: 0.763713,
    Matrices: 0.256822,
    "Number Concepts & Properties": 0.294328,
    "Number Line & Absolute Value": null,
    "Averages, Median & Mode": null,
    Counting: 0.717313,
    "Data Interpretation": 0.586498,
    Probability: 0.690149,
    "Studies & Models": null
  },
  scale23: {
    "Locating Points": null,
    Arithmetic: null,
    "Creating Expressions": 0.854535,
    "Exponents & Roots": 0.748958,
    Expressions: 0.622346,
    "Inequalities & Absolute Value": 0.449494,
    "Properties of Algebra": null,
    Slope: 0.750927,
    "Solving Equations": 0.714924,
    "Equations: Coordinate Plane": null,
    "Equations: Modeling & Relations": null,
    "Creating Functions": 0.8851,
    "Domain, Range & Function": null,
    "Function Graphs - Coordinate Plane": 0.545148,
    "Function Graphs - Modeling & Relations": null,
    "Functions - Understanding & Evaluating": 0.624628,
    Logarithms: null,
    Modeling: null,
    "Patterns & Sequences": 0.409804,
    "Properties of Functions": null,
    "Trig Functions": 0.161738,
    "Angles & Shapes": 0.597539,
    "Area, Perimeter, Volume & Circumference": 0.414747,
    "Circles & Parabolas - Coordinate Plane": 0.278725,
    "Circles - Plane Geometry": 0.637825,
    "Slope, Midpoint & Distance": 0.5,
    Logic: null,
    Symmetry: null,
    "Translation, Rotation, Reflection & Relative Equations": 0.645161,
    Triangles: 0.585235,
    "Trig Geometry": null,
    "Using Formulas": null,
    "Complex Numbers": 0.387097,
    Computation: null,
    "Exponents & Place Value": 0.814516,
    Factors: 0.799852,
    Fractions: 0.840726,
    Matrices: 0.247668,
    "Number Concepts & Properties": 0.336546,
    "Number Line & Absolute Value": null,
    "Averages, Median & Mode": null,
    Counting: 0.738695,
    "Data Interpretation": 0.620968,
    Probability: 0.739807,
    "Studies & Models": null
  },
  scale24: {
    "Locating Points": null,
    Arithmetic: null,
    "Creating Expressions": 0.8913,
    "Exponents & Roots": 0.817628,
    Expressions: 0.649724,
    "Inequalities & Absolute Value": 0.490577,
    "Properties of Algebra": null,
    Slope: 0.837978,
    "Solving Equations": 0.729012,
    "Equations: Coordinate Plane": null,
    "Equations: Modeling & Relations": null,
    "Creating Functions": 0.901491,
    "Domain, Range & Function": null,
    "Function Graphs - Coordinate Plane": 0.61165,
    "Function Graphs - Modeling & Relations": null,
    "Functions - Understanding & Evaluating": 0.698934,
    Logarithms: null,
    Modeling: null,
    "Patterns & Sequences": 0.379212,
    "Properties of Functions": null,
    "Trig Functions": 0.190939,
    "Angles & Shapes": 0.625071,
    "Area, Perimeter, Volume & Circumference": 0.47619,
    "Circles & Parabolas - Coordinate Plane": 0.33895,
    "Circles - Plane Geometry": 0.625452,
    "Slope, Midpoint & Distance": 0.628205,
    Logic: null,
    Symmetry: null,
    "Translation, Rotation, Reflection & Relative Equations": 0.75641,
    Triangles: 0.681135,
    "Trig Geometry": null,
    "Using Formulas": null,
    "Complex Numbers": 0.50641,
    Computation: null,
    "Exponents & Place Value": 0.878205,
    Factors: 0.86779,
    Fractions: 0.862179,
    Matrices: 0.30573,
    "Number Concepts & Properties": 0.333117,
    "Number Line & Absolute Value": null,
    "Averages, Median & Mode": null,
    Counting: 0.794556,
    "Data Interpretation": 0.634615,
    Probability: 0.767984,
    "Studies & Models": null
  },
  scale25: {
    "Locating Points": null,
    Arithmetic: null,
    "Creating Expressions": 0.882405,
    "Exponents & Roots": 0.820681,
    Expressions: 0.702731,
    "Inequalities & Absolute Value": 0.520752,
    "Properties of Algebra": null,
    Slope: 0.870634,
    "Solving Equations": 0.750089,
    "Equations: Coordinate Plane": null,
    "Equations: Modeling & Relations": null,
    "Creating Functions": 0.927555,
    "Domain, Range & Function": null,
    "Function Graphs - Coordinate Plane": 0.647393,
    "Function Graphs - Modeling & Relations": null,
    "Functions - Understanding & Evaluating": 0.752394,
    Logarithms: null,
    Modeling: null,
    "Patterns & Sequences": 0.451933,
    "Properties of Functions": null,
    "Trig Functions": 0.219227,
    "Angles & Shapes": 0.683398,
    "Area, Perimeter, Volume & Circumference": 0.491429,
    "Circles & Parabolas - Coordinate Plane": 0.411384,
    "Circles - Plane Geometry": 0.690316,
    "Slope, Midpoint & Distance": 0.66,
    Logic: null,
    Symmetry: null,
    "Translation, Rotation, Reflection & Relative Equations": 0.824,
    Triangles: 0.732884,
    "Trig Geometry": null,
    "Using Formulas": null,
    "Complex Numbers": 0.576,
    Computation: null,
    "Exponents & Place Value": 0.856,
    Factors: 0.862872,
    Fractions: 0.86,
    Matrices: 0.40901,
    "Number Concepts & Properties": 0.388098,
    "Number Line & Absolute Value": null,
    "Averages, Median & Mode": null,
    Counting: 0.827296,
    "Data Interpretation": 0.608,
    Probability: 0.80207,
    "Studies & Models": null
  },
  scale26: {
    "Locating Points": null,
    Arithmetic: null,
    "Creating Expressions": 0.846365,
    "Exponents & Roots": 0.775571,
    Expressions: 0.756551,
    "Inequalities & Absolute Value": 0.515638,
    "Properties of Algebra": null,
    Slope: 0.878229,
    "Solving Equations": 0.761412,
    "Equations: Coordinate Plane": null,
    "Equations: Modeling & Relations": null,
    "Creating Functions": 0.939114,
    "Domain, Range & Function": null,
    "Function Graphs - Coordinate Plane": 0.661877,
    "Function Graphs - Modeling & Relations": null,
    "Functions - Understanding & Evaluating": 0.787194,
    Logarithms: null,
    Modeling: null,
    "Patterns & Sequences": 0.480981,
    "Properties of Functions": null,
    "Trig Functions": 0.209637,
    "Angles & Shapes": 0.739856,
    "Area, Perimeter, Volume & Circumference": 0.540541,
    "Circles & Parabolas - Coordinate Plane": 0.516605,
    "Circles - Plane Geometry": 0.669696,
    "Slope, Midpoint & Distance": 0.740541,
    Logic: null,
    Symmetry: null,
    "Translation, Rotation, Reflection & Relative Equations": 0.854054,
    Triangles: 0.813609,
    "Trig Geometry": null,
    "Using Formulas": null,
    "Complex Numbers": 0.545946,
    Computation: null,
    "Exponents & Place Value": 0.962162,
    Factors: 0.887454,
    Fractions: 0.918919,
    Matrices: 0.517329,
    "Number Concepts & Properties": 0.418819,
    "Number Line & Absolute Value": null,
    "Averages, Median & Mode": null,
    Counting: 0.881919,
    "Data Interpretation": 0.632432,
    Probability: 0.843173,
    "Studies & Models": null
  },
  scale27: {
    "Locating Points": null,
    Arithmetic: null,
    "Creating Expressions": 0.920144,
    "Exponents & Roots": 0.893165,
    Expressions: 0.781295,
    "Inequalities & Absolute Value": 0.58777,
    "Properties of Algebra": null,
    Slope: 0.917073,
    "Solving Equations": 0.780576,
    "Equations: Coordinate Plane": null,
    "Equations: Modeling & Relations": null,
    "Creating Functions": 0.956098,
    "Domain, Range & Function": null,
    "Function Graphs - Coordinate Plane": 0.77554,
    "Function Graphs - Modeling & Relations": null,
    "Functions - Understanding & Evaluating": 0.847482,
    Logarithms: null,
    Modeling: null,
    "Patterns & Sequences": 0.488489,
    "Properties of Functions": null,
    "Trig Functions": 0.307554,
    "Angles & Shapes": 0.73705,
    "Area, Perimeter, Volume & Circumference": 0.592857,
    "Circles & Parabolas - Coordinate Plane": 0.529268,
    "Circles - Plane Geometry": 0.68705,
    "Slope, Midpoint & Distance": 0.7875,
    Logic: null,
    Symmetry: null,
    "Translation, Rotation, Reflection & Relative Equations": 0.825,
    Triangles: 0.840647,
    "Trig Geometry": null,
    "Using Formulas": null,
    "Complex Numbers": 0.6,
    Computation: null,
    "Exponents & Place Value": 0.95,
    Factors: 0.87561,
    Fractions: 0.95,
    Matrices: 0.503597,
    "Number Concepts & Properties": 0.495122,
    "Number Line & Absolute Value": null,
    "Averages, Median & Mode": null,
    Counting: 0.867073,
    "Data Interpretation": 0.675,
    Probability: 0.9,
    "Studies & Models": null
  },
  scale28: {
    "Locating Points": null,
    Arithmetic: null,
    "Creating Expressions": 0.897109,
    "Exponents & Roots": 0.905612,
    Expressions: 0.840136,
    "Inequalities & Absolute Value": 0.610544,
    "Properties of Algebra": null,
    Slope: 0.926282,
    "Solving Equations": 0.803997,
    "Equations: Coordinate Plane": null,
    "Equations: Modeling & Relations": null,
    "Creating Functions": 0.958333,
    "Domain, Range & Function": null,
    "Function Graphs - Coordinate Plane": 0.827381,
    "Function Graphs - Modeling & Relations": null,
    "Functions - Understanding & Evaluating": 0.867347,
    Logarithms: null,
    Modeling: null,
    "Patterns & Sequences": 0.585884,
    "Properties of Functions": null,
    "Trig Functions": 0.35119,
    "Angles & Shapes": 0.772959,
    "Area, Perimeter, Volume & Circumference": 0.678571,
    "Circles & Parabolas - Coordinate Plane": 0.63141,
    "Circles - Plane Geometry": 0.730017,
    "Slope, Midpoint & Distance": 0.775,
    Logic: null,
    Symmetry: null,
    "Translation, Rotation, Reflection & Relative Equations": 0.866667,
    Triangles: 0.868197,
    "Trig Geometry": null,
    "Using Formulas": null,
    "Complex Numbers": 0.816667,
    Computation: null,
    "Exponents & Place Value": 0.85,
    Factors: 0.948718,
    Fractions: 0.883333,
    Matrices: 0.592687,
    "Number Concepts & Properties": 0.548077,
    "Number Line & Absolute Value": null,
    "Averages, Median & Mode": null,
    Counting: 0.86859,
    "Data Interpretation": 0.766667,
    Probability: 0.919872,
    "Studies & Models": null
  },
  scale29: {
    "Locating Points": null,
    Arithmetic: null,
    "Creating Expressions": 0.962069,
    "Exponents & Roots": 0.922989,
    Expressions: 0.887356,
    "Inequalities & Absolute Value": 0.685057,
    "Properties of Algebra": null,
    Slope: 0.963303,
    "Solving Equations": 0.82069,
    "Equations: Coordinate Plane": null,
    "Equations: Modeling & Relations": null,
    "Creating Functions": 0.963303,
    "Domain, Range & Function": null,
    "Function Graphs - Coordinate Plane": 0.797701,
    "Function Graphs - Modeling & Relations": null,
    "Functions - Understanding & Evaluating": 0.9,
    Logarithms: null,
    Modeling: null,
    "Patterns & Sequences": 0.657471,
    "Properties of Functions": null,
    "Trig Functions": 0.356322,
    "Angles & Shapes": 0.781609,
    "Area, Perimeter, Volume & Circumference": 0.656085,
    "Circles & Parabolas - Coordinate Plane": 0.733945,
    "Circles - Plane Geometry": 0.868966,
    "Slope, Midpoint & Distance": 0.796296,
    Logic: null,
    Symmetry: null,
    "Translation, Rotation, Reflection & Relative Equations": 0.925926,
    Triangles: 0.882759,
    "Trig Geometry": null,
    "Using Formulas": null,
    "Complex Numbers": 0.703704,
    Computation: null,
    "Exponents & Place Value": 0.703704,
    Factors: 0.963303,
    Fractions: 0.907407,
    Matrices: 0.655172,
    "Number Concepts & Properties": 0.633028,
    "Number Line & Absolute Value": null,
    "Averages, Median & Mode": null,
    Counting: 0.93578,
    "Data Interpretation": 0.740741,
    Probability: 0.889908,
    "Studies & Models": null
  },
  scale30: {
    "Locating Points": null,
    Arithmetic: null,
    "Creating Expressions": 0.966146,
    "Exponents & Roots": 0.904514,
    Expressions: 0.881944,
    "Inequalities & Absolute Value": 0.697917,
    "Properties of Algebra": null,
    Slope: 0.914773,
    "Solving Equations": 0.831597,
    "Equations: Coordinate Plane": null,
    "Equations: Modeling & Relations": null,
    "Creating Functions": 0.977273,
    "Domain, Range & Function": null,
    "Function Graphs - Coordinate Plane": 0.902778,
    "Function Graphs - Modeling & Relations": null,
    "Functions - Understanding & Evaluating": 0.914931,
    Logarithms: null,
    Modeling: null,
    "Patterns & Sequences": 0.677083,
    "Properties of Functions": null,
    "Trig Functions": 0.375868,
    "Angles & Shapes": 0.809896,
    "Area, Perimeter, Volume & Circumference": 0.785714,
    "Circles & Parabolas - Coordinate Plane": 0.75,
    "Circles - Plane Geometry": 0.791667,
    "Slope, Midpoint & Distance": 0.791667,
    Logic: null,
    Symmetry: null,
    "Translation, Rotation, Reflection & Relative Equations": 0.833333,
    Triangles: 0.914063,
    "Trig Geometry": null,
    "Using Formulas": null,
    "Complex Numbers": 0.916667,
    Computation: null,
    "Exponents & Place Value": 0.75,
    Factors: 0.926136,
    Fractions: 1.0,
    Matrices: 0.722222,
    "Number Concepts & Properties": 0.568182,
    "Number Line & Absolute Value": null,
    "Averages, Median & Mode": null,
    Counting: 0.946023,
    "Data Interpretation": 0.958333,
    Probability: 0.931818,
    "Studies & Models": null
  },
  scale31: {
    "Locating Points": null,
    Arithmetic: null,
    "Creating Expressions": 0.975146,
    "Exponents & Roots": 0.928363,
    Expressions: 0.903509,
    "Inequalities & Absolute Value": 0.754386,
    "Properties of Algebra": null,
    Slope: 0.969388,
    "Solving Equations": 0.868421,
    "Equations: Coordinate Plane": null,
    "Equations: Modeling & Relations": null,
    "Creating Functions": 0.897959,
    "Domain, Range & Function": null,
    "Function Graphs - Coordinate Plane": 0.929825,
    "Function Graphs - Modeling & Relations": null,
    "Functions - Understanding & Evaluating": 0.97076,
    Logarithms: null,
    Modeling: null,
    "Patterns & Sequences": 0.622807,
    "Properties of Functions": null,
    "Trig Functions": 0.498538,
    "Angles & Shapes": 0.887427,
    "Area, Perimeter, Volume & Circumference": 0.892857,
    "Circles & Parabolas - Coordinate Plane": 0.755102,
    "Circles - Plane Geometry": 0.796784,
    "Slope, Midpoint & Distance": 1.0,
    Logic: null,
    Symmetry: null,
    "Translation, Rotation, Reflection & Relative Equations": 0.5,
    Triangles: 0.932749,
    "Trig Geometry": null,
    "Using Formulas": null,
    "Complex Numbers": 0.916667,
    Computation: null,
    "Exponents & Place Value": 1.0,
    Factors: 0.969388,
    Fractions: 1.0,
    Matrices: 0.877193,
    "Number Concepts & Properties": 0.755102,
    "Number Line & Absolute Value": null,
    "Averages, Median & Mode": null,
    Counting: 0.918367,
    "Data Interpretation": 0.916667,
    Probability: 0.94898,
    "Studies & Models": null
  },
  scale32: {
    "Locating Points": null,
    Arithmetic: null,
    "Creating Expressions": 1.0,
    "Exponents & Roots": 0.992105,
    Expressions: 0.905263,
    "Inequalities & Absolute Value": 0.794737,
    "Properties of Algebra": null,
    Slope: 0.962963,
    "Solving Equations": 0.863158,
    "Equations: Coordinate Plane": null,
    "Equations: Modeling & Relations": null,
    "Creating Functions": 0.981481,
    "Domain, Range & Function": null,
    "Function Graphs - Coordinate Plane": 0.942105,
    "Function Graphs - Modeling & Relations": null,
    "Functions - Understanding & Evaluating": 0.944737,
    Logarithms: null,
    Modeling: null,
    "Patterns & Sequences": 0.657895,
    "Properties of Functions": null,
    "Trig Functions": 0.668421,
    "Angles & Shapes": 0.863158,
    "Area, Perimeter, Volume & Circumference": 0.877551,
    "Circles & Parabolas - Coordinate Plane": 0.925926,
    "Circles - Plane Geometry": 0.865789,
    "Slope, Midpoint & Distance": 1.0,
    Logic: null,
    Symmetry: null,
    "Translation, Rotation, Reflection & Relative Equations": 0.0,
    Triangles: 0.902632,
    "Trig Geometry": null,
    "Using Formulas": null,
    "Complex Numbers": 1.0,
    Computation: null,
    "Exponents & Place Value": 0.857143,
    Factors: 1.0,
    Fractions: 1.0,
    Matrices: 0.826316,
    "Number Concepts & Properties": 0.666667,
    "Number Line & Absolute Value": null,
    "Averages, Median & Mode": null,
    Counting: 0.972222,
    "Data Interpretation": 0.857143,
    Probability: 0.944444,
    "Studies & Models": null
  },
  scale33: {
    "Locating Points": null,
    Arithmetic: null,
    "Creating Expressions": 0.97619,
    "Exponents & Roots": 0.952381,
    Expressions: 0.952381,
    "Inequalities & Absolute Value": 0.779762,
    "Properties of Algebra": null,
    Slope: 1.0,
    "Solving Equations": 0.889881,
    "Equations: Coordinate Plane": null,
    "Equations: Modeling & Relations": null,
    "Creating Functions": 1.0,
    "Domain, Range & Function": null,
    "Function Graphs - Coordinate Plane": 0.952381,
    "Function Graphs - Modeling & Relations": null,
    "Functions - Understanding & Evaluating": 0.916667,
    Logarithms: null,
    Modeling: null,
    "Patterns & Sequences": 0.636905,
    "Properties of Functions": null,
    "Trig Functions": 0.559524,
    "Angles & Shapes": 0.955357,
    "Area, Perimeter, Volume & Circumference": 0.928571,
    "Circles & Parabolas - Coordinate Plane": 0.775,
    "Circles - Plane Geometry": 0.955357,
    "Slope, Midpoint & Distance": 1.0,
    Logic: null,
    Symmetry: null,
    "Translation, Rotation, Reflection & Relative Equations": 0.583333,
    Triangles: 0.967262,
    "Trig Geometry": null,
    "Using Formulas": null,
    "Complex Numbers": 1.0,
    Computation: null,
    "Exponents & Place Value": 0.833333,
    Factors: 1.0,
    Fractions: 0.916667,
    Matrices: 0.89881,
    "Number Concepts & Properties": 0.85,
    "Number Line & Absolute Value": null,
    "Averages, Median & Mode": null,
    Counting: 0.9625,
    "Data Interpretation": 1.0,
    Probability: 0.975,
    "Studies & Models": null
  },
  scale34: {
    "Locating Points": null,
    Arithmetic: null,
    "Creating Expressions": 0.980892,
    "Exponents & Roots": 0.958599,
    Expressions: 0.929936,
    "Inequalities & Absolute Value": 0.859873,
    "Properties of Algebra": null,
    Slope: 0.978723,
    "Solving Equations": 0.907643,
    "Equations: Coordinate Plane": null,
    "Equations: Modeling & Relations": null,
    "Creating Functions": 1.0,
    "Domain, Range & Function": null,
    "Function Graphs - Coordinate Plane": 0.961783,
    "Function Graphs - Modeling & Relations": null,
    "Functions - Understanding & Evaluating": 1.0,
    Logarithms: null,
    Modeling: null,
    "Patterns & Sequences": 0.808917,
    "Properties of Functions": null,
    "Trig Functions": 0.767516,
    "Angles & Shapes": 0.914013,
    "Area, Perimeter, Volume & Circumference": 0.964286,
    "Circles & Parabolas - Coordinate Plane": 0.914894,
    "Circles - Plane Geometry": 0.894904,
    "Slope, Midpoint & Distance": 1.0,
    Logic: null,
    Symmetry: null,
    "Translation, Rotation, Reflection & Relative Equations": 0.5,
    Triangles: 0.971338,
    "Trig Geometry": null,
    "Using Formulas": null,
    "Complex Numbers": 0.75,
    Computation: null,
    "Exponents & Place Value": 1.0,
    Factors: 0.957447,
    Fractions: 1.0,
    Matrices: 0.847134,
    "Number Concepts & Properties": 0.93617,
    "Number Line & Absolute Value": null,
    "Averages, Median & Mode": null,
    Counting: 0.957447,
    "Data Interpretation": 1.0,
    Probability: 1.0,
    "Studies & Models": null
  },
  scale35: {
    "Locating Points": null,
    Arithmetic: null,
    "Creating Expressions": 0.911458,
    "Exponents & Roots": 0.96875,
    Expressions: 0.96875,
    "Inequalities & Absolute Value": 0.8125,
    "Properties of Algebra": null,
    Slope: 0.928571,
    "Solving Equations": 0.895833,
    "Equations: Coordinate Plane": null,
    "Equations: Modeling & Relations": null,
    "Creating Functions": 0.857143,
    "Domain, Range & Function": null,
    "Function Graphs - Coordinate Plane": 0.96875,
    "Function Graphs - Modeling & Relations": null,
    "Functions - Understanding & Evaluating": 0.96875,
    Logarithms: null,
    Modeling: null,
    "Patterns & Sequences": 0.6875,
    "Properties of Functions": null,
    "Trig Functions": 0.921875,
    "Angles & Shapes": 0.953125,
    "Area, Perimeter, Volume & Circumference": 0.952381,
    "Circles & Parabolas - Coordinate Plane": 0.964286,
    "Circles - Plane Geometry": 0.875,
    "Slope, Midpoint & Distance": 1.0,
    Logic: null,
    Symmetry: null,
    "Translation, Rotation, Reflection & Relative Equations": 1.0,
    Triangles: 0.953125,
    "Trig Geometry": null,
    "Using Formulas": null,
    "Complex Numbers": 1.0,
    Computation: null,
    "Exponents & Place Value": 1.0,
    Factors: 0.964286,
    Fractions: 1.0,
    Matrices: 0.96875,
    "Number Concepts & Properties": 0.857143,
    "Number Line & Absolute Value": null,
    "Averages, Median & Mode": null,
    Counting: 0.946429,
    "Data Interpretation": 0.666667,
    Probability: 0.964286,
    "Studies & Models": null
  },
  scale36: {
    "Locating Points": null,
    Arithmetic: null,
    "Creating Expressions": 1.0,
    "Exponents & Roots": 1.0,
    Expressions: 1.0,
    "Inequalities & Absolute Value": 1.0,
    "Properties of Algebra": null,
    Slope: 0.970588,
    "Solving Equations": 0.991228,
    "Equations: Coordinate Plane": null,
    "Equations: Modeling & Relations": null,
    "Creating Functions": 1.0,
    "Domain, Range & Function": null,
    "Function Graphs - Coordinate Plane": 1.0,
    "Function Graphs - Modeling & Relations": null,
    "Functions - Understanding & Evaluating": 1.0,
    Logarithms: null,
    Modeling: null,
    "Patterns & Sequences": 1.0,
    "Properties of Functions": null,
    "Trig Functions": 1.0,
    "Angles & Shapes": 1.0,
    "Area, Perimeter, Volume & Circumference": 1.0,
    "Circles & Parabolas - Coordinate Plane": 1.0,
    "Circles - Plane Geometry": 1.0,
    "Slope, Midpoint & Distance": 1.0,
    Logic: null,
    Symmetry: null,
    "Translation, Rotation, Reflection & Relative Equations": 1.0,
    Triangles: 1.0,
    "Trig Geometry": null,
    "Using Formulas": null,
    "Complex Numbers": 1.0,
    Computation: null,
    "Exponents & Place Value": 1.0,
    Factors: 1.0,
    Fractions: 1.0,
    Matrices: 1.0,
    "Number Concepts & Properties": 1.0,
    "Number Line & Absolute Value": null,
    "Averages, Median & Mode": null,
    Counting: 1.0,
    "Data Interpretation": 1.0,
    Probability: 1.0,
    "Studies & Models": null
  }
}

export default tsDataMath
